import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Traducciones en español
const esTranslations = {
  common: {
    loading: 'Cargando...',
    error: 'Error',
    success: 'Éxito',
    warning: 'Advertencia',
    info: 'Información',
    save: 'Guardar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    edit: 'Editar',
    add: 'Agregar',
    search: 'Buscar',
    filter: 'Filtrar',
    close: 'Cerrar',
    confirm: 'Confirmar',
    yes: 'Sí',
    no: 'No',
    back: 'Volver',
    next: 'Siguiente',
    previous: 'Anterior',
    finish: 'Finalizar',
    continue: 'Continuar',
    user: 'Usuario',
    openMenu: 'Abrir/cerrar menú lateral',
    openMobileMenu: 'Abrir menú',
    donate: 'Donar',
    logout: 'Cerrar Sesión'
  },
  auth: {
    login: 'Iniciar Sesión',
    logout: 'Cerrar Sesión',
    register: 'Registrarse',
    forgotPassword: 'Olvidé mi contraseña',
    resetPassword: 'Restablecer contraseña',
    email: 'Correo electrónico',
    password: 'Contraseña',
    confirmPassword: 'Confirmar contraseña',
    rememberMe: 'Recordarme',
    loginSuccess: 'Inicio de sesión exitoso',
    logoutSuccess: 'Sesión cerrada exitosamente',
    invalidCredentials: 'Credenciales inválidas',
    emailRequired: 'El correo electrónico es requerido',
    passwordRequired: 'La contraseña es requerida',
    loginError: 'Error al iniciar sesión'
  },
  navigation: {
    home: 'Inicio',
    dashboard: 'Dashboard',
    admin: 'Administración',
    users: 'Usuarios',
    contacts: 'Contactos',
    settings: 'Configuración',
    profile: 'Perfil',
    about: 'Acerca de',
    help: 'Ayuda',
    support: 'Soporte',
    blog: 'Blog',
    features: 'Características',
    monitor: 'Monitor',
    donations: 'Donaciones',
    privacy: 'Privacidad',
    cookies: 'Cookies',
    legal: 'Legal',
    legalNotice: 'Aviso legal',
    sitemap: 'Mapa del sitio',
    archive: 'Archivo',
    info: 'Info'
  },
  admin: {
    title: 'Panel de Administración',
    users: {
      title: 'Gestión de Usuarios',
      add: 'Agregar Usuario',
      edit: 'Editar Usuario',
      delete: 'Eliminar Usuario',
      view: 'Ver Usuario',
      list: 'Lista de Usuarios',
      details: 'Detalles del Usuario',
      roles: 'Roles',
      permissions: 'Permisos'
    },
    contacts: {
      title: 'Gestión de Mensajes',
      messages: 'Mensajes',
      inbox: 'Bandeja de entrada',
      sent: 'Enviados',
      reply: 'Responder',
      forward: 'Reenviar',
      delete: 'Eliminar',
      archive: 'Archivar'
    },
    data: {
      title: 'Gestión de Datos',
      import: 'Importar',
      export: 'Exportar',
      backup: 'Respaldo',
      restore: 'Restaurar'
    },
    config: {
      title: 'Configuración del Sistema',
      general: 'General',
      security: 'Seguridad',
      notifications: 'Notificaciones',
      maintenance: 'Mantenimiento'
    }
  },
  forms: {
    required: 'Este campo es requerido',
    invalidEmail: 'Correo electrónico inválido',
    minLength: 'Mínimo {{count}} caracteres',
    maxLength: 'Máximo {{count}} caracteres',
    passwordMismatch: 'Las contraseñas no coinciden',
    invalidFormat: 'Formato inválido',
    selectOption: 'Selecciona una opción',
    uploadFile: 'Subir archivo',
    dragDropFile: 'Arrastra y suelta un archivo aquí'
  },
  messages: {
    welcome: 'Bienvenido a {{appName}}',
    dataLoaded: 'Datos cargados exitosamente',
    dataSaved: 'Datos guardados exitosamente',
    dataDeleted: 'Datos eliminados exitosamente',
    operationCompleted: 'Operación completada',
    operationFailed: 'Operación fallida',
    networkError: 'Error de conexión',
    serverError: 'Error del servidor',
    accessDenied: 'Acceso denegado',
    notFound: 'No encontrado',
    sessionExpired: 'Sesión expirada'
  },
  sidebar: {
    collapse: 'Colapsar menú',
    expand: 'Expandir menú',
    openMenu: 'Abrir menú lateral',
    closeMenu: 'Cerrar menú lateral'
  },
  contact: {
    title: 'Contacto',
    name: 'Nombre',
    email: 'Correo electrónico',
    subject: 'Asunto',
    message: 'Mensaje',
    send: 'Enviar mensaje',
    sendSuccess: 'Mensaje enviado exitosamente',
    sendError: 'Error al enviar mensaje',
    heroTitle: 'Contáctanos',
    heroSubtitle: '¿Tienes sugerencias, necesitas soporte o simplemente quieres contactarnos? ¡Estamos aquí para ayudarte!',
    formTitle: 'Envíanos tu mensaje',
    fullName: 'Nombre completo',
    emailAddress: 'Correo electrónico',
    contactType: 'Tipo de contacto',
    relatedProduct: 'Producto relacionado',
    namePlaceholder: 'Tu nombre completo',
    emailPlaceholder: 'tu@email.com',
    messagePlaceholder: 'Describe tu consulta, sugerencia o problema en detalle...',
    sending: 'Enviando...',
    sendMessage: 'Enviar mensaje',
    invalidEmail: 'Por favor, introduce un email válido',
    fillAllFields: 'Por favor, completa todos los campos correctamente',
    successMessage: '¡Mensaje enviado exitosamente! Te responderemos pronto.',
    errorMessage: 'Error al enviar el mensaje. Por favor, inténtalo nuevamente.',
    contactTypes: {
      suggestion: 'Sugerencia',
      complaint: 'Queja',
      contact: 'Contacto General',
      support: 'Soporte Técnico',
      business: 'Consulta de Negocio'
    },
    products: {
      machine: 'Máquina de boxeo',
      app: 'Aplicación móvil',
      website: 'Página web',
      api: 'API / Servicios'
    }
  },
  pages: {
    home: {
      title: 'Inicio',
      welcome: 'Bienvenido a {{appName}}',
      description: 'MyPunch: entrenador de boxeo con IA para iPhone. Mide la fuerza y velocidad de tus golpes, entrena con combos, juega 21 tablas y compite con la comunidad. Descarga gratis.',
      heroTitle: 'Descubre tu potencia',
      heroSubtitle: 'Con MyPunch mide la fuerza de tus golpes con inteligencia artificial. Mejora tu técnica y sigue tu progreso en cada entrenamiento.',
      getStarted: 'Comenzar',
      learnMore: 'Conocer más',
      features: 'Características',
      featuresDescription: 'Descubre todo lo que puedes hacer con MyPunch'
    },
    features: {
      title: 'Características',
      description: 'Mide la fuerza de tus golpes con IA, sigue planes adaptativos de 12 semanas, entrena con combos y 21 tablas, y compite con la comunidad. Todas las características de MyPunch para iPhone.',
      heroTitle: 'Todo tu boxeo, medido con IA',
      heroSubtitle: 'Planes que se adaptan a ti, fuerza de golpe en Newtons, combos guiados, 21 tablas gamificadas y comunidad. Tu entrenador de boxeo completo en el iPhone.',
      realTimeMonitoring: 'Monitoreo en Tiempo Real',
      advancedAnalytics: 'Análisis Avanzado',
      customReports: 'Reportes Personalizados',
      secureAccess: 'Acceso Seguro',
      multiPlatform: 'Multi-plataforma',
      support247: 'Soporte 24/7'
    },
    monitor: {
      title: 'Monitor',
      description: 'Estado en tiempo real de los servicios de MyPunch. Comprueba la disponibilidad de la API, servidores y procesamiento de vídeo.',
      heroTitle: 'Monitor del Sistema',
      heroSubtitle: 'Supervisa el estado de tu infraestructura en tiempo real',
      status: 'Estado',
      online: 'En línea',
      offline: 'Fuera de línea',
      loading: 'Cargando datos...',
      lastUpdate: 'Última actualización',
      refreshData: 'Actualizar datos'
    },
    login: {
      title: 'Iniciar Sesión',
      welcomeBack: 'Bienvenido de vuelta',
      subtitle: 'Inicia sesión en tu cuenta para continuar',
      loginWithKeycloak: 'Iniciar sesión con Keycloak',
      orContinue: 'o continuar con',
      dontHaveAccount: '¿No tienes una cuenta?',
      signUp: 'Regístrate',
      forgotPassword: '¿Olvidaste tu contraseña?',
      loginError: 'Error al iniciar sesión',
      loginSuccess: 'Inicio de sesión exitoso'
    },
    donations: {
      title: 'Donaciones',
      heroTitle: 'Apoya Nuestro Proyecto',
      heroSubtitle: 'Tu donación nos ayuda a mantener y mejorar nuestra plataforma',
      whereItGoes: 'Tu ayuda se destina a investigación, mejora de la app y eventos de deportes de contacto.',
      whyDonate: '¿Por qué donar?',
      supportDevelopment: 'Apoyar el desarrollo',
      improveFeatures: 'Mejorar características',
      serverCosts: 'Costos del servidor',
      oneTime: 'Donación única',
      monthly: 'Donación mensual',
      chooseAmount: 'Elige la cantidad',
      customAmount: 'Cantidad personalizada',
      donateNow: 'Donar ahora',
      thankYou: 'Gracias por tu apoyo'
    },
    privacy: {
      title: 'Política de Privacidad',
      heroTitle: 'Política de Privacidad',
      heroSubtitle: 'Información sobre cómo recopilamos, usamos y protegemos tus datos',
      lastUpdated: 'Última actualización',
      dataCollection: 'Recopilación de Datos',
      dataUsage: 'Uso de Datos',
      dataProtection: 'Protección de Datos',
      userRights: 'Derechos del Usuario',
      contact: 'Contacto'
    },
    cookies: {
      title: 'Política de Cookies',
      heroTitle: 'Política de Cookies',
      heroSubtitle: 'Controla tu experiencia digital. Gestiona tus preferencias de cookies y conoce cómo utilizamos estas tecnologías para mejorar nuestros servicios.',
      whatAreCookies: '¿Qué son las Cookies?',
      whatAreCookiesText1: 'Las cookies son pequeños archivos de texto que los sitios web almacenan en tu dispositivo cuando los visitas. Son ampliamente utilizadas para hacer que los sitios web funcionen de manera más eficiente, así como para proporcionar información a los propietarios del sitio.',
      whatAreCookiesText2: 'En MyPunch utilizamos cookies para mejorar tu experiencia de navegación, recordar tus preferencias, analizar el tráfico del sitio y personalizar el contenido. Todas las cookies que utilizamos están diseñadas para proteger tu privacidad y seguridad.',
      cookieTypes: 'Tipos de Cookies que Utilizamos',
      necessaryCookies: 'Cookies Necesarias',
      necessaryCookiesDesc: 'Esenciales para el funcionamiento básico del sitio web. No se pueden desactivar.',
      functionalCookies: 'Cookies Funcionales',
      functionalCookiesDesc: 'Mejoran la funcionalidad y personalización del sitio web.',
      analyticsCookies: 'Cookies Analíticas',
      analyticsCookiesDesc: 'Nos ayudan a entender cómo interactúas con nuestro sitio web.',
      marketingCookies: 'Cookies de Marketing',
      marketingCookiesDesc: 'Se utilizan para mostrar anuncios relevantes y medir su efectividad.',
      specificCookies: 'Cookies Específicas que Utilizamos',
      manageCookies: 'Gestionar Preferencias de Cookies',
      manageCookiesText: 'Puedes controlar qué tipos de cookies aceptar usando los controles a continuación. Ten en cuenta que deshabilitar algunas cookies puede afectar la funcionalidad del sitio web.',
      necessaryRequired: 'Requeridas para el funcionamiento básico del sitio. No se pueden desactivar.',
      functionalDesc: 'Mejoran la funcionalidad recordando tus preferencias como tema e idioma.',
      analyticsDesc: 'Nos ayudan a entender cómo usas el sitio para mejorarlo continuamente.',
      marketingDesc: 'Utilizadas para mostrar anuncios relevantes y medir su efectividad.',
      savePreferences: 'Guardar Preferencias',
      saveSuccess: 'Preferencias de cookies guardadas exitosamente',
      browserGuide: 'Gestionar Cookies en tu Navegador',
      browserGuideText: 'También puedes gestionar las cookies directamente desde tu navegador. Aquí te mostramos cómo hacerlo en los navegadores más populares:',
      moreInfo: 'Más Información',
      moreInfoText1: 'Para obtener más información sobre cómo manejamos tus datos personales, consulta nuestra',
      moreInfoText2: 'Si tienes preguntas sobre nuestro uso de cookies, no dudes en contactarnos a través de nuestra',
      tableHeaders: {
        name: 'Nombre',
        purpose: 'Propósito',
        duration: 'Duración',
        type: 'Tipo'
      },
      cookieData: {
        gaAnalytics: 'Google Analytics - Análisis de tráfico',
        gidSession: 'Google Analytics - Identificación de sesión',
        sessionManagement: 'Gestión de sesión de usuario',
        themePreference: 'Preferencia de tema (claro/oscuro)',
        languagePreference: 'Preferencia de idioma',
        session: 'Sesión',
        necessary: 'Necesaria',
        functional: 'Funcional',
        analytic: 'Analítica',
        twoYears: '2 años',
        twentyFourHours: '24 horas',
        oneYear: '1 año'
      },
      browserSteps: {
        chrome: 'Configuración > Privacidad y seguridad > Cookies y otros datos de sitios',
        firefox: 'Opciones > Privacidad & Seguridad > Cookies y datos de sitios',
        safari: 'Preferencias > Privacidad > Gestionar datos de sitios web',
        edge: 'Configuración > Privacidad, búsqueda y servicios > Cookies'
      },
      links: {
        privacyPolicy: 'Política de Privacidad',
        contactPage: 'página de contacto'
      },
      detail: {
        title: 'Detalle del Elemento',
        backToHome: 'Volver al Inicio',
        goBack: 'Volver',
        share: 'Compartir',
        sharingWindow: 'Ventana de compartir abierta',
        shareSuccess: 'Contenido compartido exitosamente',
        shareError: 'Error al compartir el contenido',
        featuredFunctionality: 'Funcionalidad destacada',
        readingTime: 'Tiempo de lectura: ~2 min',
        previous: 'Anterior',
        next: 'Siguiente',
        notFound: 'Elemento no encontrado',
        notFoundDescription: 'El elemento que buscas no existe',
        elementNotFoundWithId: 'El elemento con ID "{{id}}" no se pudo encontrar en nuestra base de datos.',
        breadcrumbHome: 'Inicio',
        categoryLabels: {
          feature: 'Características',
          service: 'Servicios',
          product: 'Productos',
          default: 'Elementos'
        },
        shareText: 'Descubre {{title}} en MyPunch',
        socialNetworks: {
          twitter: 'Twitter',
          facebook: 'Facebook',
          whatsapp: 'WhatsApp',
          linkedin: 'LinkedIn'
        }
      }
    },
    detail: {
      title: 'Detalle del Elemento',
      backToHome: 'Volver al Inicio',
      goBack: 'Volver',
      share: 'Compartir',
      sharingWindow: 'Ventana de compartir abierta',
      shareSuccess: 'Contenido compartido exitosamente',
      shareError: 'Error al compartir el contenido',
      featuredFunctionality: 'Funcionalidad destacada',
      readingTime: 'Tiempo de lectura: ~2 min',
      previous: 'Anterior',
      next: 'Siguiente',
      notFound: 'Elemento no encontrado',
      notFoundDescription: 'El elemento que buscas no existe',
      elementNotFoundWithId: 'El elemento con ID "{{id}}" no se pudo encontrar en nuestra base de datos.',
      breadcrumbHome: 'Inicio',
      imageOf: 'Imagen de',
      previousElement: 'Elemento anterior',
      nextElement: 'Siguiente elemento',
      shareOn: 'Compartir en',
      categoryLabels: {
        feature: 'Características',
        service: 'Servicios',
        product: 'Productos',
        default: 'Elementos'
      },
      shareText: 'Descubre {{title}} en MyPunch',
      socialNetworks: {
        twitter: 'Twitter',
        facebook: 'Facebook',
        whatsapp: 'WhatsApp',
        linkedin: 'LinkedIn'
      },
      items: [
        {
          title: 'Monitorización en tiempo real',
          description: '<p><strong>¿Quieres saber exactamente cómo estás golpeando en cada momento?</strong> Con nuestra <em>monitorización en tiempo real</em>, tendrás al instante todos los datos que necesitas para mejorar tu técnica. Desde la <span style="color:#e63946;">fuerza</span> hasta la <span style="color:#e63946;">velocidad</span> de cada golpe, puedes visualizarlo todo al instante.</p><p>No hay necesidad de esperar para obtener análisis de tu rendimiento: los verás mientras entrenas.</p><p>Gracias a esta tecnología avanzada, puedes ajustar tu postura, corregir errores y mejorar cada golpe en tiempo real. ¿Qué mejor manera de mejorar que tener un <em>entrenador virtual</em> en la palma de tu mano?</p>'
        },
        {
          title: 'Datos detallados',
          description: '<p>Con <strong>MyPunch</strong>, no solo entrenas: <em>analizas, optimizas y triunfas</em>. Gracias a nuestra función de <strong>datos detallados</strong>, tendrás acceso a un análisis profundo de cada entrenamiento.</p><p>¿Quieres llevar tu entrenamiento al siguiente nivel? Con estos datos, puedes personalizar tu enfoque y concentrarte en las áreas que realmente importan.</p><p>Nuestros gráficos y resúmenes de rendimiento te ayudarán a visualizar tu progreso de manera clara. Con <strong>MyPunch</strong>, tendrás las herramientas para entrenar como un profesional.</p>'
        },
        {
          title: 'Entrenamientos personalizados',
          description: '<p>¿Cansado de planes genéricos que no se adaptan a ti? Con <strong>MyPunch</strong> crea rutinas de boxeo diseñadas para tus metas y habilidades.</p><p>Nuestra función de <strong>entrenamientos personalizados</strong> te permite configurar la intensidad, la duración y el tipo de entrenamiento que más te convenga.</p><p><em>La personalización es clave para obtener resultados más rápidos.</em></p><p><strong>No importa si eres principiante o experto</strong>, nuestros entrenamientos están diseñados para llevarte al siguiente nivel.</p>'
        },
        {
          title: 'Comparte tus resultados',
          description: '<p><strong>¡Es hora de mostrar al mundo tu progreso!</strong> Con <strong>MyPunch</strong> puedes compartir tus logros con tu comunidad.</p><p>Publica fácilmente tus estadísticas y videos de entrenamiento en redes sociales, inspirando a otros y manteniéndote motivado.</p><p>Al compartir tus resultados, puedes recibir el apoyo de amigos y familiares, y competir amistosamente con otros usuarios.</p>'
        },
        {
          title: 'Estadísticas en tiempo real',
          description: '<p>La precisión es clave, y con las <strong>estadísticas en tiempo real</strong> de <strong>MyPunch</strong> sabrás exactamente cómo te desempeñas en cada momento.</p><p>Desde el primer golpe hasta el último, puedes <span style="color:#e63946;">monitorear tu rendimiento minuto a minuto</span>, ajustando tu técnica sobre la marcha.</p><p>Si te encanta la competencia, puedes comparar tus estadísticas con las de otros usuarios en tiempo real.</p>'
        },
        {
          title: 'Repetición',
          description: '<p>La <strong>repetición</strong> es clave para dominar cualquier técnica. Con <strong>MyPunch</strong> puedes repetir y analizar cada movimiento con precisión.</p><p>Nuestra función de repetición te permite grabar y revisar tus sesiones, observando desde diferentes ángulos cómo mejorar tu postura, velocidad y potencia.</p><p><em>Imagina ver tus primeros entrenamientos y compararlos con los más recientes.</em> Verás una mejora constante que te motivará a seguir.</p>'
        }
      ]
    }
  },
  footer: {
    logoAlt: 'Logo MyPunch',
    sectionNavigation: 'Navegación',
    sectionLegal: 'Legal',
    sectionContact: 'Contacto',
    features: 'Características',
    donations: 'Donaciones',
    sitemap: 'Mapa del sitio',
    privacy: 'Privacidad',
    cookies: 'Cookies',
    companyDescription: 'MyPunch. Innovando en tecnologías de monitoreo inteligente para deportes de contacto.',
    copyright: 'Todos los derechos reservados.',
    madeWith: 'Hecho con',
    madeBy: 'por el equipo de YasYLLC',
    socialLinks: {
      instagram: 'Instagram',
      twitter: 'Twitter',
      reddit: 'Reddit'
    },
    navigation: {
      home: 'Inicio',
      features: 'Características',
      monitor: 'Monitor',
      contact: 'Contacto',
      blog: 'Blog',
      donations: 'Donaciones'
    },
    contact: {
      email: 'contacto@punchia.online',
      phone: '+34 900 123 456'
    }
  },
  cookieConsent: {
    message: 'Este sitio web utiliza cookies para mejorar la experiencia de usuario. Al hacer clic en "Aceptar", consientes el uso de cookies.',
    accept: 'Aceptar',
    learnMore: 'Saber más'
  },
  testimonials: {
    title: 'Opinión de nuestros usuarios',
    users: [
      {
        name: 'Carlos Martínez',
        comment: '¡Increíble app! He mejorado mucho mi técnica gracias a la monitorización en tiempo real.'
      },
      {
        name: 'María Gómez',
        comment: 'Los análisis detallados son muy útiles para ver mis progresos, lo recomiendo mucho.'
      },
      {
        name: 'Juan Pérez',
        comment: 'Me encantó poder compartir mis resultados en redes, ¡una gran motivación para seguir entrenando!'
      },
      {
        name: 'Ana Fernández',
        comment: 'El entrenamiento personalizado se adapta perfecto a mis objetivos, es justo lo que buscaba.'
      }
    ]
  },
  bentoBox: {
    welcomeTo: 'Bienvenido a',
    appName: 'MyPunch'
  },
  faq: {
    title: 'Preguntas frecuentes',
    items: [
      { q: '¿En qué dispositivos está disponible MyPunch?', a: 'MyPunch está disponible en iPhone (iOS). Puedes descargarla desde la App Store.' },
      { q: '¿Cómo mide la fuerza de mis golpes?', a: 'Usamos análisis de video e inteligencia artificial para estimar la potencia y velocidad de cada golpe a partir de tu cámara.' },
      { q: '¿Qué son las "Tablas"?', a: 'Son 21 minijuegos de entrenamiento (técnica, defensa, cardio, fuerza y recuperación) con estrellas y récords para que entrenes jugando.' },
      { q: '¿Puedo competir con otras personas?', a: 'Sí: añade amigos, lánzales retos y compite en las clasificaciones globales.' },
      { q: '¿Sirve para entrenadores?', a: 'Sí. Puedes gestionar varios alumnos y exportar informes de progreso en PDF.' },
      { q: '¿Se integra con Apple Health?', a: 'Sí, tus entrenamientos se exportan automáticamente a Apple Health (calorías, duración y actividad).' },
      { q: '¿Mis datos están seguros?', a: 'Sí. Tratamos tus datos con total confidencialidad. Consulta nuestra Política de Privacidad para más detalles.' },
      { q: '¿Puedo usar MyPunch sin conexión?', a: 'Parte de la app funciona sin conexión; algunas funciones requieren internet para sincronizar tu progreso.' }
    ]
  },
  errorBoundary: {
    title: '¡Oops! Algo salió mal',
    description: 'Ha ocurrido un error inesperado. Nuestro equipo ha sido notificado.',
    reloadPage: 'Recargar página',
    goHome: 'Ir al inicio',
    errorDetails: 'Detalles del error (desarrollo)',
    error: 'Error:',
    stackTrace: 'Stack trace:'
  }
};

// Traducciones en inglés
const enTranslations = {
  common: {
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    warning: 'Warning',
    info: 'Information',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    search: 'Search',
    filter: 'Filter',
    close: 'Close',
    confirm: 'Confirm',
    yes: 'Yes',
    no: 'No',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    finish: 'Finish',
    continue: 'Continue',
    user: 'User',
    openMenu: 'Open/close sidebar menu',
    openMobileMenu: 'Open menu',
    donate: 'Donate',
    logout: 'Logout'
  },
  auth: {
    login: 'Login',
    logout: 'Logout',
    register: 'Register',
    forgotPassword: 'Forgot Password',
    resetPassword: 'Reset Password',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    rememberMe: 'Remember Me',
    loginSuccess: 'Login successful',
    logoutSuccess: 'Logout successful',
    invalidCredentials: 'Invalid credentials',
    emailRequired: 'Email is required',
    passwordRequired: 'Password is required',
    loginError: 'Login error'
  },
  navigation: {
    home: 'Home',
    dashboard: 'Dashboard',
    admin: 'Administration',
    users: 'Users',
    contacts: 'Contacts',
    settings: 'Settings',
    profile: 'Profile',
    about: 'About',
    help: 'Help',
    support: 'Support',
    blog: 'Blog',
    features: 'Features',
    monitor: 'Monitor',
    donations: 'Donations',
    privacy: 'Privacy',
    cookies: 'Cookies',
    legal: 'Legal',
    legalNotice: 'Legal notice',
    sitemap: 'Site map',
    archive: 'Archive',
    info: 'Info'
  },
  admin: {
    title: 'Administration Panel',
    users: {
      title: 'User Management',
      add: 'Add User',
      edit: 'Edit User',
      delete: 'Delete User',
      view: 'View User',
      list: 'User List',
      details: 'User Details',
      roles: 'Roles',
      permissions: 'Permissions'
    },
    contacts: {
      title: 'Message Management',
      messages: 'Messages',
      inbox: 'Inbox',
      sent: 'Sent',
      reply: 'Reply',
      forward: 'Forward',
      delete: 'Delete',
      archive: 'Archive'
    },
    data: {
      title: 'Data Management',
      import: 'Import',
      export: 'Export',
      backup: 'Backup',
      restore: 'Restore'
    },
    config: {
      title: 'System Configuration',
      general: 'General',
      security: 'Security',
      notifications: 'Notifications',
      maintenance: 'Maintenance'
    }
  },
  forms: {
    required: 'This field is required',
    invalidEmail: 'Invalid email',
    minLength: 'Minimum {{count}} characters',
    maxLength: 'Maximum {{count}} characters',
    passwordMismatch: 'Passwords do not match',
    invalidFormat: 'Invalid format',
    selectOption: 'Select an option',
    uploadFile: 'Upload file',
    dragDropFile: 'Drag and drop a file here'
  },
  messages: {
    welcome: 'Welcome to {{appName}}',
    dataLoaded: 'Data loaded successfully',
    dataSaved: 'Data saved successfully',
    dataDeleted: 'Data deleted successfully',
    operationCompleted: 'Operation completed',
    operationFailed: 'Operation failed',
    networkError: 'Network error',
    serverError: 'Server error',
    accessDenied: 'Access denied',
    notFound: 'Not found',
    sessionExpired: 'Session expired'
  },
  sidebar: {
    collapse: 'Collapse menu',
    expand: 'Expand menu',
    openMenu: 'Open sidebar menu',
    closeMenu: 'Close sidebar menu'
  },
  contact: {
    title: 'Contact',
    name: 'Name',
    email: 'Email',
    subject: 'Subject',
    message: 'Message',
    send: 'Send message',
    sendSuccess: 'Message sent successfully',
    sendError: 'Error sending message',
    heroTitle: 'Contact Us',
    heroSubtitle: 'Have suggestions, need support or simply want to contact us? We\'re here to help you!',
    formTitle: 'Send Us Your Message',
    fullName: 'Full Name',
    emailAddress: 'Email',
    contactType: 'Contact Type',
    relatedProduct: 'Related Product',
    namePlaceholder: 'Your full name',
    emailPlaceholder: 'you@email.com',
    messagePlaceholder: 'Describe your query, suggestion or problem in detail...',
    sending: 'Sending...',
    sendMessage: 'Send Message',
    invalidEmail: 'Please enter a valid email',
    fillAllFields: 'Please fill in all fields correctly',
    successMessage: 'Message sent successfully! We\'ll get back to you soon.',
    errorMessage: 'Error sending message. Please try again.',
    contactTypes: {
      suggestion: 'Suggestion',
      complaint: 'Complaint',
      contact: 'General Contact',
      support: 'Technical Support',
      business: 'Business Inquiry'
    },
    products: {
      machine: 'Boxing Machine',
      app: 'Mobile App',
      website: 'Website',
      api: 'API / Services'
    }
  },
  pages: {
    home: {
      title: 'Home',
      welcome: 'Welcome to {{appName}}',
      description: 'MyPunch: AI boxing coach for iPhone. Measure your punch force and speed, train with combos, play 21 drills and compete with the community. Download free.',
      heroTitle: 'Discover your power',
      heroSubtitle: 'With MyPunch, measure your punch strength using AI. Improve your technique and track your progress with every session.',
      getStarted: 'Get Started',
      learnMore: 'Learn More',
      features: 'Features',
      featuresDescription: 'Discover everything you can do with MyPunch'
    },
    features: {
      title: 'Features',
      description: 'Measure your punch force with AI, follow adaptive 12-week plans, train with combos and 21 drills, and compete with the community. Every MyPunch feature for iPhone.',
      heroTitle: 'Your whole boxing game, measured by AI',
      heroSubtitle: 'Plans that adapt to you, punch force in Newtons, guided combos, 21 gamified drills and community. Your complete boxing coach on iPhone.',
      realTimeMonitoring: 'Real-Time Monitoring',
      advancedAnalytics: 'Advanced Analytics',
      customReports: 'Custom Reports',
      secureAccess: 'Secure Access',
      multiPlatform: 'Multi-platform',
      support247: '24/7 Support'
    },
    monitor: {
      title: 'Monitor',
      description: 'Real-time status of MyPunch services. Check API availability, server health and video processing status.',
      heroTitle: 'System Monitor',
      heroSubtitle: 'Monitor the status of your infrastructure in real time',
      status: 'Status',
      online: 'Online',
      offline: 'Offline',
      loading: 'Loading data...',
      lastUpdate: 'Last update',
      refreshData: 'Refresh data'
    },
    login: {
      title: 'Login',
      welcomeBack: 'Welcome back',
      subtitle: 'Sign in to your account to continue',
      loginWithKeycloak: 'Sign in with Keycloak',
      orContinue: 'or continue with',
      dontHaveAccount: 'Don\'t have an account?',
      signUp: 'Sign up',
      forgotPassword: 'Forgot your password?',
      loginError: 'Login error',
      loginSuccess: 'Login successful'
    },
    donations: {
      title: 'Donations',
      heroTitle: 'Support Our Project',
      heroSubtitle: 'Your donation helps us maintain and improve our platform',
      whereItGoes: 'Your support goes to research, app improvement and contact sports events.',
      whyDonate: 'Why donate?',
      supportDevelopment: 'Support development',
      improveFeatures: 'Improve features',
      serverCosts: 'Server costs',
      oneTime: 'One-time donation',
      monthly: 'Monthly donation',
      chooseAmount: 'Choose amount',
      customAmount: 'Custom amount',
      donateNow: 'Donate now',
      thankYou: 'Thank you for your support'
    },
    privacy: {
      title: 'Privacy Policy',
      heroTitle: 'Privacy Policy',
      heroSubtitle: 'Information about how we collect, use and protect your data',
      lastUpdated: 'Last updated',
      dataCollection: 'Data Collection',
      dataUsage: 'Data Usage',
      dataProtection: 'Data Protection',
      userRights: 'User Rights',
      contact: 'Contact'
    },
    cookies: {
      title: 'Cookie Policy',
      heroTitle: 'Cookie Policy',
      heroSubtitle: 'Control your digital experience. Manage your cookie preferences and learn how we use these technologies to improve our services.',
      whatAreCookies: 'What are Cookies?',
      whatAreCookiesText1: 'Cookies are small text files that websites store on your device when you visit them. They are widely used to make websites work more efficiently, as well as to provide information to site owners.',
      whatAreCookiesText2: 'At MyPunch we use cookies to improve your browsing experience, remember your preferences, analyze site traffic and personalize content. All cookies we use are designed to protect your privacy and security.',
      cookieTypes: 'Types of Cookies We Use',
      necessaryCookies: 'Necessary Cookies',
      necessaryCookiesDesc: 'Essential for basic website functionality. Cannot be disabled.',
      functionalCookies: 'Functional Cookies',
      functionalCookiesDesc: 'Improve website functionality and personalization.',
      analyticsCookies: 'Analytics Cookies',
      analyticsCookiesDesc: 'Help us understand how you interact with our website.',
      marketingCookies: 'Marketing Cookies',
      marketingCookiesDesc: 'Used to display relevant ads and measure their effectiveness.',
      specificCookies: 'Specific Cookies We Use',
      manageCookies: 'Manage Cookie Preferences',
      manageCookiesText: 'You can control which types of cookies to accept using the controls below. Note that disabling some cookies may affect website functionality.',
      necessaryRequired: 'Required for basic site functionality. Cannot be disabled.',
      functionalDesc: 'Improve functionality by remembering your preferences like theme and language.',
      analyticsDesc: 'Help us understand how you use the site to continuously improve it.',
      marketingDesc: 'Used to display relevant ads and measure their effectiveness.',
      savePreferences: 'Save Preferences',
      saveSuccess: 'Cookie preferences saved successfully',
      browserGuide: 'Manage Cookies in Your Browser',
      browserGuideText: 'You can also manage cookies directly from your browser. Here\'s how to do it in the most popular browsers:',
      moreInfo: 'More Information',
      moreInfoText1: 'For more information about how we handle your personal data, see our',
      moreInfoText2: 'If you have questions about our use of cookies, please contact us through our',
      tableHeaders: {
        name: 'Name',
        purpose: 'Purpose',
        duration: 'Duration',
        type: 'Type'
      },
      cookieData: {
        gaAnalytics: 'Google Analytics - Traffic analysis',
        gidSession: 'Google Analytics - Session identification',
        sessionManagement: 'User session management',
        themePreference: 'Theme preference (light/dark)',
        languagePreference: 'Language preference',
        session: 'Session',
        necessary: 'Necessary',
        functional: 'Functional',
        analytic: 'Analytics',
        twoYears: '2 years',
        twentyFourHours: '24 hours',
        oneYear: '1 year'
      },
      browserSteps: {
        chrome: 'Settings > Privacy and security > Cookies and other site data',
        firefox: 'Options > Privacy & Security > Cookies and site data',
        safari: 'Preferences > Privacy > Manage Website Data',
        edge: 'Settings > Privacy, search, and services > Cookies'
      },
      links: {
        privacyPolicy: 'Privacy Policy',
        contactPage: 'contact page'
      },
      detail: {
        title: 'Element Detail',
        backToHome: 'Back to Home',
        goBack: 'Go Back',
        share: 'Share',
        sharingWindow: 'Sharing window opened',
        shareSuccess: 'Content shared successfully',
        shareError: 'Error sharing content',
        featuredFunctionality: 'Featured functionality',
        readingTime: 'Reading time: ~2 min',
        previous: 'Previous',
        next: 'Next',
        notFound: 'Element not found',
        notFoundDescription: 'The element you are looking for does not exist',
        elementNotFoundWithId: 'The element with ID "{{id}}" could not be found in our database.',
        breadcrumbHome: 'Home',
        categoryLabels: {
          feature: 'Features',
          service: 'Services',
          product: 'Products',
          default: 'Elements'
        },
        shareText: 'Discover {{title}} on MyPunch',
        socialNetworks: {
          twitter: 'Twitter',
          facebook: 'Facebook',
          whatsapp: 'WhatsApp',
          linkedin: 'LinkedIn'
        }
      }
    },
    detail: {
      title: 'Element Detail',
      backToHome: 'Back to Home',
      goBack: 'Go Back',
      share: 'Share',
      sharingWindow: 'Sharing window opened',
      shareSuccess: 'Content shared successfully',
      shareError: 'Error sharing content',
      featuredFunctionality: 'Featured functionality',
      readingTime: 'Reading time: ~2 min',
      previous: 'Previous',
      next: 'Next',
      notFound: 'Element not found',
      notFoundDescription: 'The element you are looking for does not exist',
      elementNotFoundWithId: 'The element with ID "{{id}}" could not be found in our database.',
      breadcrumbHome: 'Home',
      imageOf: 'Image of',
      previousElement: 'Previous element',
      nextElement: 'Next element',
      shareOn: 'Share on',
      categoryLabels: {
        feature: 'Features',
        service: 'Services',
        product: 'Products',
        default: 'Elements'
      },
      shareText: 'Discover {{title}} on MyPunch',
      socialNetworks: {
        twitter: 'Twitter',
        facebook: 'Facebook',
        whatsapp: 'WhatsApp',
        linkedin: 'LinkedIn'
      },
      items: [
        {
          title: 'Real-time monitoring',
          description: '<p><strong>Want to know exactly how you\'re hitting at every moment?</strong> With our <em>real-time monitoring</em>, you\'ll instantly have all the data you need to improve your technique. From the <span style="color:#e63946;">force</span> to the <span style="color:#e63946;">speed</span> of each punch, you can see it all in real time.</p><p>No need to wait for performance analysis: you\'ll see it as you train.</p><p>Thanks to this advanced technology, you can adjust your stance, correct errors and improve each punch in real time. What better way to improve than having a <em>virtual coach</em> in the palm of your hand?</p>'
        },
        {
          title: 'Detailed data',
          description: '<p>With <strong>MyPunch</strong>, you don\'t just train: <em>you analyze, optimize and succeed</em>. Thanks to our <strong>detailed data</strong> feature, you\'ll have access to in-depth analysis of every workout.</p><p>Want to take your training to the next level? With this data, you can personalise your approach and focus on what really matters.</p><p>Our performance charts and summaries help you visualise your progress clearly. With <strong>MyPunch</strong>, you\'ll have the tools to train like a pro.</p>'
        },
        {
          title: 'Custom workouts',
          description: '<p>Tired of generic plans that don\'t suit you? With <strong>MyPunch</strong> create boxing routines designed for your goals and skill level.</p><p>Our <strong>custom workouts</strong> feature lets you set intensity, duration and the type of workout that works best for you.</p><p><em>Personalisation is key to getting faster results.</em></p><p><strong>Whether you\'re a beginner or an expert</strong>, our workouts are designed to take you to the next level.</p>'
        },
        {
          title: 'Share your results',
          description: '<p><strong>Time to show the world your progress!</strong> With <strong>MyPunch</strong> you can share your achievements with your community.</p><p>Easily post your stats and training videos on social media, inspiring others and staying motivated.</p><p>By sharing your results, you can get support from friends and family, and compete with other users in a friendly way.</p>'
        },
        {
          title: 'Real-time statistics',
          description: '<p>Accuracy is key, and with <strong>MyPunch</strong>\'s <strong>real-time statistics</strong> you\'ll know exactly how you\'re performing at every moment.</p><p>From the first punch to the last, you can <span style="color:#e63946;">monitor your performance minute by minute</span>, adjusting your technique on the fly.</p><p>If you love competition, you can compare your stats with other users in real time.</p>'
        },
        {
          title: 'Repetition',
          description: '<p><strong>Repetition</strong> is key to mastering any technique. With <strong>MyPunch</strong> you can repeat and analyse every movement with precision.</p><p>Our repetition feature lets you record and review your sessions, watching from different angles how to improve your stance, speed and power.</p><p><em>Imagine seeing your first workouts and comparing them to your latest ones.</em> You\'ll see steady improvement that will keep you motivated.</p>'
        }
      ]
    }
  },
  footer: {
    logoAlt: 'MyPunch Logo',
    sectionNavigation: 'Navigation',
    sectionLegal: 'Legal',
    sectionContact: 'Contact',
    features: 'Features',
    donations: 'Donations',
    sitemap: 'Site map',
    privacy: 'Privacy',
    cookies: 'Cookies',
    companyDescription: 'MyPunch. Innovating in smart monitoring technologies for contact sports.',
    copyright: 'All rights reserved.',
    madeWith: 'Made with',
    madeBy: 'by the YasYLLC team',
    socialLinks: {
      instagram: 'Instagram',
      twitter: 'Twitter',
      reddit: 'Reddit'
    },
    navigation: {
      home: 'Home',
      features: 'Features',
      monitor: 'Monitor',
      contact: 'Contact',
      blog: 'Blog',
      donations: 'Donations'
    },
    contact: {
      email: 'contacto@punchia.online',
      phone: '+34 900 123 456'
    }
  },
  cookieConsent: {
    message: 'This website uses cookies to improve user experience. By clicking "Accept", you consent to the use of cookies.',
    accept: 'Accept',
    learnMore: 'Learn more'
  },
  testimonials: {
    title: 'What our users think',
    users: [
      {
        name: 'Carlos Martínez',
        comment: 'Amazing app! I have improved my technique a lot thanks to real-time monitoring.'
      },
      {
        name: 'María Gómez',
        comment: 'The detailed analysis is very useful to see my progress, I highly recommend it.'
      },
      {
        name: 'Juan Pérez',
        comment: 'I loved being able to share my results on social media, a great motivation to keep training!'
      },
      {
        name: 'Ana Fernández',
        comment: 'The personalized training adapts perfectly to my goals, it\'s just what I was looking for.'
      }
    ]
  },
  bentoBox: {
    welcomeTo: 'Welcome to',
    appName: 'MyPunch'
  },
  faq: {
    title: 'Frequently asked questions',
    items: [
      { q: 'On which devices is MyPunch available?', a: 'MyPunch is available on iPhone (iOS). You can download it from the App Store.' },
      { q: 'How does it measure punch strength?', a: 'We use video analysis and AI to estimate the power and speed of each punch from your camera.' },
      { q: 'What are the "Drills"?', a: 'They are 21 training mini-games (technique, defense, cardio, strength and recovery) with stars and high scores so you can train while you play.' },
      { q: 'Can I compete with other people?', a: 'Yes: add friends, challenge them and compete on the global leaderboards.' },
      { q: 'Is it useful for coaches?', a: 'Yes. You can manage multiple students and export progress reports as PDF.' },
      { q: 'Does it integrate with Apple Health?', a: 'Yes, your workouts export automatically to Apple Health (calories, duration and activity).' },
      { q: 'Is my data secure?', a: 'Yes. We treat your data in strict confidence. See our Privacy Policy for details.' },
      { q: 'Can I use MyPunch offline?', a: 'Part of the app works offline; some features need internet to sync your progress.' }
    ]
  },
  errorBoundary: {
    title: 'Oops! Something went wrong',
    description: 'An unexpected error has occurred. Our team has been notified.',
    reloadPage: 'Reload page',
    goHome: 'Go to home',
    errorDetails: 'Error details (development)',
    error: 'Error:',
    stackTrace: 'Stack trace:'
  }
};

// Configuración de i18next
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: {
        translation: esTranslations
      },
      en: {
        translation: enTranslations
      }
    },
    lng: 'es', // idioma por defecto
    fallbackLng: 'es',
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng'
    },
    
    interpolation: {
      escapeValue: false
    },
    
    react: {
      useSuspense: false
    }
  });

export default i18n; 